import { render, staticRenderFns } from "./CContentSlider.vue?vue&type=template&id=289fd8ab&scoped=true&"
import script from "./CContentSlider.vue?vue&type=script&lang=ts&"
export * from "./CContentSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CContentSlider.vue?vue&type=style&index=0&id=289fd8ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289fd8ab",
  null
  
)

export default component.exports